import React,{Component} from 'react';

class DeliveryViewDetails extends Component{

	
          
    render() {
        
        return (
            <tr>
                <td>
                    <p>{this.props.product.qty}</p>                    
                </td>
                <td>
                    <p>{this.props.product.unit}</p>                    
                </td>
                <td>
                    <p>{this.props.product.name}</p>
                </td>                  
                          
              
            </tr>	    
        );
    }
}

export default  DeliveryViewDetails;


// WEBPACK FOOTER //
// ./src/components/DeliveryViewDetails.js